module.exports = __webpack_public_path__ + "img/busrealistic.56a9815a.png";